/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import { orderBy } from 'lodash';
import { memo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '..';
import { prettyNumber } from '../../helper';

interface Props {
  /**
   * Number of duplicates in the spreadsheet, per insurance code.
   */
  readonly duplicateCounts: Readonly<Record<string, number>>;
}

const DuplicateCodes = ({ duplicateCounts }: Props) => (
  <table
    css={css`
      border-collapse: separate;
      border-spacing: 0;
      height: 100%;
      width: 100%;
    `}
  >
    <tbody>
      <td
        css={css`
          height: 100%;
          vertical-align: top;
        `}
      >
        <TableContainer
          css={css`
            height: 100%;
            max-height: 100%;
          `}
        >
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Insurance Code</TableCell>
                <TableCell align='right'># Duplicates</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderBy(
                Object.entries(duplicateCounts),
                ([, count]) => count,
                'desc'
              ).map(([code, count]) => (
                <TableRow key={code}>
                  <TableCell>{code}</TableCell>
                  <TableCell align='right'>{prettyNumber(count)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </td>
    </tbody>
  </table>
);

export default memo(DuplicateCodes);
